export default "__VITE_ASSET__BelUFtUm__"